import { ERRORS } from 'constants.js';
import { Logger } from 'wtb-utils';

const getFieldErrors = (error) => {
  const getFieldName = (name) => {
    const _name = name
      .replace('billing.', '')
      .replace('contact.', '');

    switch (_name) {
      case 'name.first': return 'firstName';
      case 'name.last': return 'lastName';
      case 'nationalId': return 'nationalId';
      case 'email': return 'email';
      case 'phone': return 'phone';
      case 'address.street': return 'street';
      case 'address.streetAdditional': return 'streetAdditional';
      case 'address.zip': return 'zipCode';
      case 'address.city': return 'city';
      case 'address.country': return 'country';
      default:
        Logger.error(`Field name ${name} (${_name}) not supported.`);
        return null;
    }
  };

  const getErrorMessage = (name, message) => {
    switch (message) {
      case 'INVALID_FORMAT':
      default:
        return `errors.${name}.${message.toLowerCase()}`;
    }
  };

  if ([ ERRORS.INVALID_DATA, ERRORS.INVALID_PARAMETER ].includes(error.message)) {
    const errors = [];

    if (error.body.detail?.includes('national id')) {
      errors.push({ name: 'nationalId', message: 'errors.nationalId.invalid_format' });
    } else if (error.body.invalidParameters) {
      error.body.invalidParameters.forEach((parameter) => {
        const name = getFieldName(parameter.name);

        if (!name) {
          Logger.error(`Field ${parameter.name} not found.`);
        } else {
          const message = getErrorMessage(name, parameter.details);
          errors.push({ name, message });
        }
      });
    }

    return errors;
  } else {
    return null;
  }
};

export default getFieldErrors;
